import axios from 'axios'

export const getAllCarriers = (params) => {
  let remoteUrl = 'carriers'

  return axios.get(remoteUrl, {params: params})
}

export const getAllCarrierZhCod = (params) => {
  let remoteUrl = 'carriers-allow-export-zh-cod'

  return axios.get(remoteUrl, {params: params})
}




// WEBPACK FOOTER //
// ./src/api/carriers.js